const Account = ({ data }) => (
  <section className="account-grid container pv6">
    <Info
      heading={data.heading}
      paragraph={data.paragraph}
      artist={data.artist}
      company={data.company}
    />
    <Reveal css={{ opacity: `0`, transform: `translateX(200px)` }}>
      <Img
        sizes={data.image.childImageSharp.sizes}
        alt={data.alt}
        critical={data.critical}
        className="ml-auto mr-auto w-75"
      />
    </Reveal>
  </section>
)

/*
 *
 * General
 * 
 */

import React from 'react'

import Img from '../components/Img'
import Reveal from '../components/Reveal'

/*
 *
 * Info
 * 
 */

import LearnMore from '../components/LearnMore'

const Info = ({ heading, paragraph, artist, company }) => (
  <div className="account-ga-info">
    <h2 className="subheading mb3">{heading}</h2>
    <p className="mb5 measure-narrow lh-copy f-lead">{paragraph}</p>
    <div className="account-types-grid">
      <User type={artist.type} features={artist.features} />
      <User type={company.type} features={company.features} />
    </div>
    <LearnMore className="btn mb6" />
  </div>
)

/*
 *
 * User
 * 
 */

import shortid from 'shortid'

import FaChevronRight from 'react-icons/lib/fa/chevron-right'

const User = ({ type, features }) => (
  <div>
    <h3 className="heading mb4 fw9 gold">{type} Account</h3>
    <ul className="mb5">
      {features.map(feature => (
        <li key={shortid.generate()} className="flex items-center mb3 lh-copy">
          <FaChevronRight className="flex-none mr2 lead gold" />
          {feature}
        </li>
      ))}
    </ul>
  </div>
)

export default Account



// WEBPACK FOOTER //
// ./src/sections/Account.js